import { successIcon, failureIcon, warningIcon, paymentIcon } from "../src/shared/icons";

const whitelabel = (document.body.getAttribute('data-whitelabel') == 'true')
const style = getComputedStyle(document.body)
const primaryColor = style.getPropertyValue('--primary-color')
const secondaryColor = style.getPropertyValue('--secondary-color')

const iconHandler = (icon) => {
  return whitelabel ? gritterIcon(icon) : ''
}

const gritterIcon = (icon) => {
  return '<div class="gritter-image"><span class="md-icon"><span class="' + icon + '"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span></span></div>'
}

const imageHandler = (henriIcon) => {
  return whitelabel ? '' : henriIcon
}

const whitelabelPaymentIcon = () => {
  return `<span class="vue-icons">
                <span class="icon-payment md-icon">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                  <span class="path5"></span>
                  <span class="path6"></span>
                </span>
              </span>`
}

export let whitelabelStore = {
  whitelabel: whitelabel,
  primaryColor: primaryColor,
  secondaryColor: whitelabel ? secondaryColor : '#2e2e2e',
  iconSuccess: iconHandler('icon-success-gritter'),
  imageSuccess: imageHandler(successIcon),
  iconWarning: iconHandler('icon-warning-gritter'),
  imageWarning: imageHandler(warningIcon),
  iconFailure: iconHandler('icon-failure-gritter'),
  imageFailure: imageHandler(failureIcon),
  iconPayment: iconHandler(whitelabelPaymentIcon),
  imagePayment: imageHandler(paymentIcon)
}
